// The Mixpanel dedupe key, shared verbatim with the backend and the platform.
//
// $insert_id is validated by Mixpanel: at most 36 bytes, and only [A-Za-z0-9-].
// An id that breaks either rule is rejected and the event is ingested UNDEDUPED
// — which is what the old `${userId}:${eventName}` scheme did (45 bytes, plus
// `:` and `_`), letting all three senders count. So the key is `${userId}-${code}`
// with a short alphanumeric per-event code: 27 bytes for a 24-char ObjectId, all
// characters legal. The event name doesn't need to be in the id — Mixpanel dedupes
// on (event name, distinct_id, $insert_id), so the code only has to keep the funnel
// steps apart within one user.

// The events we dedupe across the three senders. They live here next to the code
// map so the two can't drift apart.
export const REGISTRATION_STARTED = "registration_started";
export const REGISTRATION_COMPLETED = "registration_completed";

const INSERT_ID_MAX_BYTES = 36;
const INSERT_ID_ALLOWED = /^[A-Za-z0-9-]+$/;
const INSERT_ID_CODES = {
  [REGISTRATION_STARTED]: "rs",
  [REGISTRATION_COMPLETED]: "rc",
};

/** Deterministic $insert_id for `eventName`. Returns undefined for events we
 *  don't dedupe, for a missing userId, and for any id the constraints above would
 *  reject — the event then goes out with no $insert_id, exactly as every
 *  non-deduped event already does. */
export const buildInsertId = (userId, eventName) => {
  const code = INSERT_ID_CODES[eventName];
  if (!code || !userId) return undefined;
  const insertId = `${userId}-${code}`;
  // Charset check first: it also guarantees ASCII, so length === byte length.
  if (!INSERT_ID_ALLOWED.test(insertId)) return undefined;
  if (insertId.length > INSERT_ID_MAX_BYTES) return undefined;
  return insertId;
};
